export const passwordThemes = {
  nature: [
    "tree", "river", "stone", "cloud", "leaf", "bush", "hill", "rain", "sun",
    "wind", "soil", "grass", "moon", "star", "lake", "sea", "wave", "sand",
    "rock", "flower", "bird", "fish", "deer", "frog", "worm", "pond", "bark",
    "twig", "root", "seed", "snow", "fog", "ice", "storm", "breeze", "dawn",
    "dusk", "moss", "dust", "reed", "shell", "fern", "vine", "cliff", "cave",
    "trail", "petal", "puddle", "branch", "field"
  ],
  food_and_drink: [
    "bread", "rice", "pasta", "milk", "water", "tea", "juice", "soup", "cake",
    "beef", "pork", "fish", "salt", "sugar", "honey", "jam", "butter", "cream",
    "cheese", "egg", "chili", "onion", "beans", "carrot", "peach", "plum", "nut",
    "olive", "yogurt", "berry", "corn", "pear", "apple", "lemon", "lime", "melon",
    "grape", "kiwi", "mango", "coffee", "soda", "cider", "toast", "sauce", "salad",
    "pizza", "taco", "bacon", "basil", "spice"
  ],
  family: [
    "mother", "father", "sister", "brother", "aunt", "uncle", "cousin", "niece", "nephew",
    "grandma", "grandpa", "parent", "child", "twin", "baby", "wife", "husband", "son",
    "daughter", "family", "kin", "relative", "spouse", "in-law", "stepmom", "stepdad",
    "stepson", "stepbrother", "stepdaughter", "stepfather", "mother-in-law", "father-in-law",
    "sibling", "ancestor", "descendant", "partner", "guardian", "adopt", "foster", "household",
    "marriage", "engage", "divorce", "wedding", "bride", "groom", "clan", "tribe", "lineage"
  ],
  emotions: [
    "happy", "sad", "angry", "calm", "scared", "brave", "joy", "grief", "fear",
    "love", "hate", "proud", "shy", "bored", "tired", "relaxed", "anxious", "lucky",
    "jealous", "guilty", "hope", "worry", "trust", "surprise", "shock", "envy", "pity",
    "shame", "peace", "anger", "regret", "delight", "confuse", "excite", "curious",
    "content", "frustrate", "lonely", "gloomy", "thrilled", "annoyed", "cheerful",
    "grateful", "inspire", "relief", "tense", "amused", "fond"
  ],
  travel: [
    "plane", "train", "bus", "car", "taxi", "boat", "ship", "bike", "map",
    "hotel", "motel", "hostel", "ticket", "trip", "tour", "guide", "route", "visa",
    "passport", "luggage", "baggage", "journey", "adventure", "explore", "cruise",
    "resort", "camp", "hike", "sail", "drive", "fly", "ride", "walk", "trek",
    "station", "airport", "harbor", "port", "cabin", "ferry", "check-in", "departure",
    "arrival", "customs", "border", "sight", "landmark", "destination", "itinerary"
  ],
  colors: [
    "red", "blue", "green", "yellow", "pink", "black", "white", "gray", "brown",
    "orange", "purple", "violet", "indigo", "teal", "beige", "maroon", "gold", "silver",
    "navy", "aqua", "turquoise", "lime", "peach", "tan", "cyan", "magenta", "olive",
    "lavender", "cream", "rust", "coral", "bronze", "scarlet", "amber", "ivory",
    "plum", "emerald", "jade", "cherry", "azure", "chartreuse", "fuchsia", "mauve",
    "saffron", "taupe", "ebony", "charcoal", "sapphire", "crimson"
  ],
  weather: [
    "sunny", "rainy", "cloudy", "stormy", "windy", "snowy", "foggy", "humid", "dry",
    "cold", "warm", "hot", "cool", "wet", "breeze", "gust", "thunder", "lightning",
    "hail", "drizzle", "frost", "blizzard", "hurricane", "cyclone", "mist", "drought",
    "tornado", "dew", "overcast", "gale", "sleet", "shower", "monsoon", "tempest",
    "zephyr", "squall", "bitter", "chill", "muggy", "swelter", "flood", "rainbow",
    "drop", "draft", "forecast", "climate", "season", "ice"
  ],
  clothing: [
    "shirt", "pants", "jeans", "dress", "skirt", "coat", "jacket", "sweater", "blouse",
    "hat", "cap", "scarf", "gloves", "socks", "shoes", "boots", "sneakers", "tie",
    "belt", "shorts", "t-shirt", "vest", "hoodie", "uniform", "suit", "gown", "blazer",
    "robe", "jumper", "cardigan", "pajamas", "swimsuit", "sandals", "heels", "sari",
    "sundress", "tunic", "kimono", "bonnet", "beanie", "shawl", "mittens", "leggings",
    "trousers", "pullover", "anorak", "parka", "beret"
  ],
  sports: [
    "football", "tennis", "basketball", "baseball", "golf", "swim", "run", "cycle", "yoga",
    "hike", "climb", "ski", "surf", "dive", "judo", "karate", "boxing", "gymnastics",
    "cricket", "rugby", "volleyball", "hockey", "rowing", "sailing", "fencing", "archery",
    "badminton", "squash", "ping-pong", "bowling", "skate", "snowboard", "track", "field",
    "marathon", "triathlon", "race", "relay", "jump", "throw", "catch", "kick", "dribble",
    "pass", "score", "win", "lose", "draw", "team"
  ],
  music: [
    "song", "band", "singer", "piano", "guitar", "drum", "violin", "flute", "trumpet",
    "sax", "cello", "harp", "bass", "choir", "opera", "jazz", "rock", "pop", "folk",
    "blues", "rap", "hip-hop", "classical", "country", "reggae", "disco", "duet",
    "soprano", "tenor", "alto", "baritone", "note", "melody", "harmony", "rhythm",
    "beat", "tempo", "lyrics", "tune", "concert", "gig", "album", "record", "single",
    "hit", "track", "chorus", "verse", "bridge"
  ],
  education: [
    "school", "class", "teacher", "student", "desk", "book", "pen", "pencil", "chalk",
    "board", "lesson", "homework", "test", "exam", "quiz", "grade", "subject", "math",
    "science", "history", "art", "music", "sport", "library", "college", "university",
    "degree", "diploma", "lecture", "course", "study", "learn", "read", "write", "listen",
    "speak", "spell", "count", "draw", "paint", "computer", "paper", "notebook", "ruler",
    "eraser", "calculator", "projector", "backpack", "uniform"
  ],
  technology: [
    "computer", "phone", "tablet", "laptop", "mouse", "keyboard", "screen", "monitor",
    "printer", "camera", "internet", "email", "website", "software", "program", "app",
    "game", "robot", "network", "data", "file", "drive", "cloud", "server", "web",
    "link", "click", "download", "upload", "code", "text", "video", "audio", "stream",
    "chat", "social", "media", "search", "engine", "device", "battery", "cable", "signal",
    "wireless", "bluetooth", "gadget", "remote", "update", "backup"
  ],
  jobs_and_professions: [
    "doctor", "nurse", "teacher", "engineer", "lawyer", "pilot", "chef", "artist",
    "writer", "farmer", "driver", "cook", "waiter", "police", "fireman", "dentist",
    "scientist", "builder", "plumber", "electrician", "mechanic", "architect", "actor",
    "singer", "musician", "dancer", "manager", "clerk", "cashier", "sales", "nanny",
    "gardener", "carpenter", "barber", "hairdresser", "tailor", "painter", "designer",
    "photographer", "journalist", "editor", "accountant", "banker", "librarian", "coach",
    "trainer", "guide", "judge", "athlete"
  ],
  transportation: [
    "car", "bus", "train", "plane", "bike", "taxi", "truck", "van", "ship", "boat",
    "scooter", "tram", "subway", "ferry", "helicopter", "motorcycle", "skateboard",
    "rollerblade", "cart", "canoe", "kayak", "raft", "cruise", "yacht", "gondola", "metro",
    "jeep", "limousine", "rickshaw", "trolley", "hot-air", "balloon", "sailboat", "jet",
    "cable", "car", "drone", "hovercraft", "sledge", "sled", "hoverboard", "quad", "skis",
    "snowmobile", "paraglider", "bicycle", "monorail", "funicular", "spaceship"
  ],
  animals: [
    "cat", "dog", "fish", "bird", "cow", "horse", "sheep", "goat", "pig", "chicken",
    "duck", "geese", "turkey", "rabbit", "mouse", "rat", "hamster", "guinea", "parrot",
    "turtle", "frog", "snake", "lizard", "crocodile", "alligator", "eagle", "hawk",
    "swan", "owl", "lion", "tiger", "bear", "wolf", "fox", "deer", "elephant", "giraffe",
    "zebra", "kangaroo", "koala", "panda", "monkey", "gorilla", "chimpanzee", "dolphin",
    "whale", "shark", "octopus", "jellyfish"
  ],
};
